import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Panel, SectionLabel } from '@/ui';
import type { Community } from '@/core/models/community';

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Row = styled.li`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
`;
const When = styled.span`
  font-family: ${({ theme }) => theme.font.mono};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;
const Empty = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

export function UpcomingEventsPanel({ community }: { community: Community }) {
  return (
    <Panel>
      <SectionLabel as="h2">Upcoming Events</SectionLabel>
      {community.events.length === 0 ? (
        <Empty>No upcoming events.</Empty>
      ) : (
        <List>
          {community.events.map((e) => (
            <Row key={e.slug ?? e.title}>
              {e.slug ? (
                <Link to={`/events/${encodeURIComponent(e.slug)}`}>{e.title}</Link>
              ) : (
                <span>{e.title}</span>
              )}
              <When>{e.startsAt ? new Date(e.startsAt).toLocaleString() : e.date}</When>
            </Row>
          ))}
        </List>
      )}
    </Panel>
  );
}
